import React, { useState } from "react";
import DatePicker from "react-date-picker";
// import DateView from 'react-datepicker'
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";
// import "./../../assets/css/react-datepicker.css";

function DatePicker2(props) {
  const [valuee, onChange] = useState(new Date());
  const { label, name, ...rest } = props;
  return (
    <div className="form-control">
      <label htmlFor={name}>{label}</label>
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          const { value } = field;
          return (
            // <DatePicker onChange={onChange} value={value} />
            <DatePicker
              // id={name}
              // {...field}
              // {...rest}
              onChange={onChange}
              value={valuee}
              // selected={value}
              // onChange={(val) => setFieldValue(name, val)}
            />
          );
        }}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default DatePicker2;
